import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { PatchPath, PutPath } from '@/lib/restClient/apiPath';
import { AuthStoreDeliveryAreasParams } from '@/pages/delivery/in-house/useDeliveryAreas';

interface Interface {
  put: (params: AuthStoreDeliveryAreasParams) => Promise<void>;
  changePassword: (body: ChangePasswordForm) => Promise<void>;
}

export interface ChangePasswordForm {
  auth_store_id: number;
  new_password: string;
  new_password_confirm: string;
}

export class AuthStoresService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async put(params: AuthStoreDeliveryAreasParams): Promise<void> {
    return await this.restClient.put(
      `${TABLET_API_ORIGIN}/dashboard-api/auth-stores/${params.auth_store_id}/delivery-areas` as PutPath,
      params
    );
  }

  public async changePassword(body: ChangePasswordForm): Promise<void> {
    return await this.restClient.patch<ChangePasswordForm, void>(
      `${TABLET_API_ORIGIN}/dashboard-api/auth-stores/${body.auth_store_id}/password` as PatchPath,
      body
    );
  }
}
